import React from 'react';
import CustomNavbar from '../components/CustomNavbar';
import FooterTwo from '../components/Footer/FooterTwo';
import FooterData from '../components/Footer/FooterData';
import GetInTouch from '../components/GetInTouch';
import Docs from '../components/Docs/Docs';
import AppGetstarted from '../components/AppGetstarted';

const docs = [
    { teamImage: 'doc_01.png', title: 'Quick Start Guide', fileName: 'Web Service Quick Start Guide.EN.pdf' },
    { teamImage: 'doc_02.png', title: 'Schnellstart Handbuch', fileName: 'Web Service Quick Start Guide.DE.pdf' }
]

const brochures = [
    { teamImage: 'brochure_01.png', title: 'Hemdahl Analytics Brochure', fileName: 'food_short_eu.pdf' },
    { teamImage: 'brochure_02.png', title: 'Hemdahl Analytics Broschüre"', fileName: 'food_short_de.pdf' }
]

const whitePapers = [
    { teamImage: 'whitepaper_01.png', title:"Predicting Product Temperatures", fileName: 'Hemdahl_WP_101_Predicting_Product_Temperatures.pdf' },
    { teamImage: 'whitepaper_02.png', title:"Pathogen Growth Prediction", fileName: 'Hemdahl_WP_102_Pathogen_Growth_Prediction.pdf' },
    { teamImage: 'whitepaper_03.png', title:"Shelf Life Prediction", fileName: 'Hemdahl_WP_103_Shelf_Life_Prediction.pdf' },
    { teamImage: 'whitepaper_04.png', title:"Cold Treatment Verification", fileName: 'Hemdahl_WP_104_Cold_Treatment_Verification.pdf' },
]

const Resources = () => {
    return(
        <div className="body_wrapper justify-content-center">
            <CustomNavbar className="mb_70" cClass="custom_container p0" hbtnClass="new_btn"/>
            <Docs title="Whitepapers" docs={whitePapers} />
            <Docs title="Brochures" docs={brochures} />
            <Docs title="User Guides" docs={docs} />
            <AppGetstarted/>
            <GetInTouch/>
            <FooterTwo FooterData={FooterData}/>
        </div>
    )
}
export default Resources;